import { Shuffle } from "@mui/icons-material";
import { Backdrop, CircularProgress, Stack, Typography } from "@mui/material";
import { runDraw } from "apis/controllers/clearings";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import { useState } from "react";
import LotteryConfirmDialog from "./LotteryConfirmDialog";
import LotteryTable from "./LotteryTable"; // ✅ new responsive table
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";

// Dummy API function
function dummyApiCall() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        status: "success",
        message: "Dummy API call executed successfully."
      });
    }, 2500); // simulate network delay
  });
}



const Lottery = ({ data, fetchClearings }) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [loading, setLoading] = useState(false);

  const { seasonId } = useSelector(state => state.auth)

  const applicationTypes = [
    {
      id: 1,
      label: "Τρίτεκνες Μητέρες",
      total: 230,
      limit: 200,
      requiresTermination: true,
    },
    { id: 2, label: "Πολύτεκνες Μητέρες", total: 120, limit: 200 },
    { id: 3, label: "Επιτυχόντες Πανελλαδικών", total: 310, limit: 300 },
  ];

  const handleOpenConfirm = (type) => {
    setSelectedType(type);
    setOpenConfirm(true);
  };

  const handleConfirmLottery = async () => {
    console.log("Running lottery for:", selectedType);
    setOpenConfirm(false);
    setLoading(true);

    try {
      // 🔹 Swap this line while testing
      const res = await runDraw({ seasonId: seasonId ?? 2025, typeId: selectedType?.typeId });
      enqueueSnackbar(res?.message, { variant: res?.status },)

      if (res?.status === "error") {
        console.error(res?.message);
        return;
      }
      if (res?.status === 'success')
        if (fetchClearings) fetchClearings();
    } catch (err) {
      enqueueSnackbar('Προέκυψε σφάλμα κατά την κλήρωση!', { variant: 'error' },)
      console.error("Error completing review period:", err);
    } finally {
      setLoading(false);
    }
  };


  return (
    <CustomSimpleAccordion
      defaultOpen
      title={
        <Stack direction="row" gap={1}>
          <Shuffle
            color="primary"
            fontSize="small"
            sx={{ marginLeft: "2px" }}
          />
          <Typography variant="h4" color="primary" sx={{ fontWeight: 700 }}>
            Διενέργεια Κλήρωσης
          </Typography>
        </Stack>
      }
      content={
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Εδώ μπορείτε να εκτελέσετε τη διαδικασία κλήρωσης για τις επιλέξιμες
            αιτήσεις.
          </Typography>

          {/* --- Responsive Table --- */}
          <LotteryTable
            applicationTypes={data}
            onConfirmDialog={handleOpenConfirm}
          />

          {/* --- Confirmation Dialog --- */}
          <LotteryConfirmDialog
            open={openConfirm}
            onClose={() => setOpenConfirm(false)}
            onLottery={handleConfirmLottery}
            loading={loading}
          />
          <Backdrop open={loading} sx={{ color: "#fff", zIndex: 2000 }}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Stack>
      }
    />
  );
};

export default Lottery;
